import { render, staticRenderFns } from "./ChannelUserModal.vue?vue&type=template&id=6e8926a0&scoped=true"
import script from "./ChannelUserModal.vue?vue&type=script&lang=js"
export * from "./ChannelUserModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelUserModal.vue?vue&type=style&index=0&id=6e8926a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8926a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8926a0')) {
      api.createRecord('6e8926a0', component.options)
    } else {
      api.reload('6e8926a0', component.options)
    }
    module.hot.accept("./ChannelUserModal.vue?vue&type=template&id=6e8926a0&scoped=true", function () {
      api.rerender('6e8926a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChannelUser/ChannelUserModal.vue"
export default component.exports